module.exports = __webpack_public_path__ + "img/screenshot2.943e26e3.jpg";